/* eslint-disable linebreak-style */
//
// Organization constants for Balance Point Studios
// -------------------------------------------------------------
// Mission text is copied verbatim from the Ohio Articles of
// Incorporation (Form 532B, Document ID 202314901352, filed
// 5/29/2023). Do not paraphrase here without legal review.
//

export const ORG_NAME = 'Balance Point Studios';
export const ORG_SHORT_NAME = 'BPS';
export const ORG_TAGLINE = 'Where Cleveland youth find their balance.';

export const ORG_MISSION = 'We create a space for youth in the Mt. Pleasant Neighborhood of Cleveland, Ohio to learn and experience creative self-expression through artistic instruction, mentorship and guidance, and personal development. We pay specific attention to self-discovery, and through our programming we aim to help youth redefine their future to break unfavorable generational cycles.';

// Public Ohio Secretary of State record
export const ORG_ADDRESS_STREET = '3396 Westbury Rd';
export const ORG_ADDRESS_CITY = 'Cleveland';
export const ORG_ADDRESS_STATE = 'OH';
export const ORG_ADDRESS_ZIP = '44120-4214';
export const ORG_ADDRESS_FULL = '3396 Westbury Rd, Cleveland, OH 44120-4214';
export const ORG_LOCALE = 'Cleveland, Cuyahoga County, Ohio';

// TODO: replace when domain confirmed.
export const ORG_EMAIL = 'info@balancepointstudios.org';

// Filing identifiers (Ohio SOS)
export const ORG_CHARTER_NUMBER = '5057559';
export const ORG_DOC_ID = '202314901352';
export const ORG_FOUNDED_DATE = '2023-05-29';
export const ORG_FOUNDED_LABEL = 'May 29, 2023';
export const ORG_ENTITY_TYPE = 'Ohio Nonprofit, Domestic Corporation';

// People
export const ORG_FOUNDER = 'Allison Black';
export const ORG_FOUNDER_ROLE = 'Founder & Director';

// Tax-exempt notice — must appear on /donate and /about until IRS issues
// 501(c)(3) determination. Sourced from Form 532B note.
export const TAX_NOTICE = 'Balance Point Studios is incorporated as an Ohio nonprofit. 501(c)(3) federal tax-exempt status with the IRS is pending; donations may not yet be tax-deductible. Please consult your tax advisor.';

// Program slugs used as :slug param on /programs/:slug routes
export const PROGRAM_SLUGS = {
  ARTISTIC: 'artistic-instruction',
  MENTORSHIP: 'mentorship',
  PERSONAL: 'personal-development',
};
